import { render, staticRenderFns } from "./ContentGoodToKnowBlock.vue?vue&type=template&id=237d1de8"
import script from "./ContentGoodToKnowBlock.vue?vue&type=script&lang=js"
export * from "./ContentGoodToKnowBlock.vue?vue&type=script&lang=js"
import style0 from "./ContentGoodToKnowBlock.vue?vue&type=style&index=0&id=237d1de8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports